import { render, staticRenderFns } from "./relatorio-dashboard.vue?vue&type=template&id=012cc741&scoped=true&"
import script from "./relatorio-dashboard.vue?vue&type=script&lang=js&"
export * from "./relatorio-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./relatorio-dashboard.vue?vue&type=style&index=0&id=012cc741&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cc741",
  null
  
)

export default component.exports